<!--
 * @Description: 提现记录
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-29 18:25:25
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span> 提现记录 </span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="back">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <!-- <v-list>
              <v-list-item v-for="(item, i) in 5" :key="i" @click="() => {}">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text">
          <v-list-item two-line v-for="(item, index) in data" :key="index" >
            <v-list-item-content>
                <v-list-item-title>
                    <v-chip
                    class="ma-2"
                    color="black"
                    text-color="black"
                    small
                    outlined
                  >
                  {{ (item.fee/100).toFixed(2) }} 元
                  </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>
                  <span v-if="item.status == 3021" >【 转入可提现 】</span>
                  <span v-if="item.status == 3022" >【 提现申请 】</span>
                  <span v-if="item.status == 3023" >【 提现处理中 】</span>
                  <span v-if="item.status == 3024" >【 提现成功 】</span>
                  <span v-if="item.status == 3025" >【 提现失败 】</span>
                  <span v-if="item.status == 3026" >【 提现失败退款 】</span>
                  {{ item.create_time | time }}
              </v-list-item-subtitle>
            </v-list-item-content>
           </v-list-item>
           <p v-if="data.length == 0"> 暂无记录... </p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="back">返回提现</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      data:[]
    };
  },
  methods: {
    info(state) {
      this.dialog = state;
    //   order_transfer_list
    this.$axios({
        method: "get",
        url: this.$apis.URL.order_transfer_list,
        data: {}
      })
        .then((req) => {
          if(req.data.result == 0){
            this.$Dialog.getProductCheckResult_({text: `提现列表请求成功！`,timeout: 3000, snackbar: true });
            this.data = req.data.datas;
          }else{
            this.$Dialog.getProductCheckResult_({text: req.data.message,timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({text: error,timeout: 3000, snackbar: true });
        });
    },
    // 返回弹出提现操作框
    back(){
        this.dialog = false;
        this.$parent.back();
    }
  }
};
</script>